import type { FacilityItem } from "../Interfaces/FacilityInterface";

/** Short human-readable facility label for UI (displayName preferred over legal name). */
export function getFacilityLabel(f: {
  displayName?: string | null;
  name?: string | null;
}): string {
  return (f.displayName ?? f.name ?? "").trim();
}

/** Resolve facility label by id from a facilities list. */
export function getFacilityLabelById(
  facilityId: string | undefined | null,
  facilities: FacilityItem[]
): string {
  if (!facilityId?.trim()) return "";
  const facility = facilities.find((f) => f.id === facilityId.trim());
  return facility ? getFacilityLabel(facility) : "";
}
